import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Cookie } from 'lucide-react';

export default function ArtikelEidSuessigkeitenSelberMachen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Süßigkeiten selber machen: 10 einfache Rezepte</h1>
          <p className="text-lg text-white/80 leading-relaxed">Selbstgemachte Süßigkeiten als Geschenk oder für die Festtafel – mit diesen einfachen Rezepten gelingt es garantiert.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Selbstgemachte Süßigkeiten zu Eid sind etwas ganz Besonderes – sie zeigen Liebe und Mühe. Ob als Geschenk für Besucher, für die Festtafel oder als hübsche Mitbringsel: Mit diesen 10 Rezepten zauberst du orientalische Köstlichkeiten, die alle begeistern.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Cookie className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Klassische orientalische Süßigkeiten</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">1. Maamoul (Dattelkekse)</h4>
                <p className="text-sm text-[#4B5563]">Der Klassiker zu Eid: Mürbe Kekse gefüllt mit einer süßen Dattelpaste, gewürzt mit Zimt und Kardamom. Werden traditionell in schönen Holzformen gepresst.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Mittel | Menge: ca. 30 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">2. Baklava</h4>
                <p className="text-sm text-[#4B5563]">Schicht für Schicht: Phyllo-Teig, gebuttert, mit gehackten Pistazien und Walnüssen, übergossen mit Zuckersirup und Rosenwasser. Etwas aufwändig, aber jede Mühe wert!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Fortgeschritten | Menge: ca. 40 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">3. Basbousa (Grießkuchen)</h4>
                <p className="text-sm text-[#4B5563]">Saftiger Grießkuchen mit Kokosflocken, getränkt in Zuckersirup mit einem Hauch Orangenblütenwasser. Einfach und schnell – perfekt für Anfänger.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Für ca. 20 Portionen</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Pralinen & Konfekt</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">4. Dattel-Trüffel</h4>
                <p className="text-sm text-[#4B5563]">Medjool-Datteln gefüllt mit Mandelbutter, getaucht in Schokolade und bestreut mit Pistazien. Elegant und in 30 Minuten fertig – perfekt als Geschenk!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Menge: ca. 20 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">5. Rosenwasser-Kokos-Kugeln</h4>
                <p className="text-sm text-[#4B5563]">Kokosraspeln, Kondensmilch und ein Hauch Rosenwasser – gerollt in Kugeln und in Pistazien gewälzt. Kein Backen nötig!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Menge: ca. 25 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">6. Turkish Delight (Lokum)</h4>
                <p className="text-sm text-[#4B5563]">Weiche, puderzuckerbestäubte Würfel aus Stärke und Zucker, aromatisiert mit Rose, Zitrone oder Pistazie. Braucht etwas Geduld, aber das Ergebnis ist beeindruckend.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Mittel | Menge: ca. 50 Stück</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Moderne Varianten</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">7. Eid Cake Pops</h4>
                <p className="text-sm text-[#4B5563]">Kuchenlollies in Mondform, dekoriert mit Gold- und Grünakzenten. Perfekt für Kinder und als essbare Deko auf der Festtafel.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Mittel | Menge: ca. 20 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">8. Pistazienschokolade</h4>
                <p className="text-sm text-[#4B5563]">Geschmolzene weiße und dunkle Schokolade marmoriert mit Pistazien, Rosenblüten und essbarem Gold. Sieht atemberaubend aus und ist super einfach!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Für ca. 10 Tafeln</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">9. Saffron Milchkuchen</h4>
                <p className="text-sm text-[#4B5563]">Indisch inspirierter Milchkuchen mit Safran und Kardamom. Dicht, aromatisch und unglaublich lecker. Wird kalt serviert.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Für ca. 16 Stück</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">10. Dattel-Karamell-Popcorn</h4>
                <p className="text-sm text-[#4B5563]">Popcorn mit selbstgemachtem Dattelkaramell und einer Prise Meersalz. Süß, salzig, knusprig – ein Favorit bei Alt und Jung!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Schwierigkeit: Leicht | Für ca. 6 Portionen</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Verpackungsideen</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Geschenkboxen:</strong> Kleine Kartons mit "Eid Mubarak"-Aufklebern füllen</li>
                <li><strong>Zellophan-Beutel:</strong> Mit Schleife und Anhänger – klassisch und elegant</li>
                <li><strong>Einmachgläser:</strong> Schichten von verschiedenen Süßigkeiten sehen besonders hübsch aus</li>
                <li><strong>Pralinenformen:</strong> Goldene Pappförmchen verleihen einen luxuriösen Look</li>
                <li><strong>Kinder-Tüten:</strong> Bunte Tüten mit Eid-Stickern und einer Mischung verschiedener Süßigkeiten</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Selbstgemachte Süßigkeiten sind das herzlichste Geschenk zu Eid. Sie kosten wenig, schmecken unvergleichlich und zeigen deinen Lieben: Du bist mir die Mühe wert. Probiere ein oder zwei Rezepte aus und mache dieses Eid zu etwas Besonderem!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/halal-suessigkeiten-deutschland" className="text-[#4A5D4F] hover:underline">→ Halal Süßigkeiten in Deutschland</Link></li>
              <li><Link to="/ratgeber/diy-geschenke-eid" className="text-[#4A5D4F] hover:underline">→ DIY Geschenke zu Eid</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
